import { addFilter } from '@situation/setdesign.util';

addFilter('content-slider/owl-settings', (options) => ({ ...options, nav: false }));
